/** API route map: URLS.Controller.Designation */
export const Designation = {
      Name: 'Designation/',
      AddDesignation: 'add-designation',
      EditDesignation: 'update-designation',
      DeleteDesignation: 'delete-designation',
      GetAllDesignation: 'get-designation',
      GetDropDownDesignation: 'get-designationdropdown',
};
